import styled from 'styled-components';
import { palette } from 'styled-tools';

import {
	Checkbox,
	CheckboxVerticalAlign,
	FontSizes,
	FontWeights,
	Text,
	units,
} from '@calm-web/design-system';

export const Container = styled.div`
	display: flex;
	padding: ${units(3)};
	background-color: ${palette('white')};
	border-radius: ${units(2)};
	margin-bottom: ${units(3)};
`;

export const TocCheckbox = styled(Checkbox).attrs({
	isStrong: true,
	verticalAlignment: CheckboxVerticalAlign.Top,
})``;

export const TocText = styled(Text).attrs({
	el: 'p',
	size: FontSizes.sm,
	color: 'gray8',
	weight: FontWeights.Medium,
	noMargin: true,
})`
	letter-spacing: 0.1px;
`;

export const LegalLink = styled.a`
	color: ${palette('blue3')};
`;
